// extracted by mini-css-extract-plugin
export default {"score":"competitorlistscoresheet_score__VQ6j+"};